/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */

package com.narbase.letsgo.router

import com.narbase.letsgo.models.roles.AdminPrivilege


abstract class EndPoint<Request : Any, out Response : Any> {
    private var _path: String? = null
    var path: String
        get() = _path ?: throw RuntimeException("Endpoint ${this::class.simpleName} path is not initialized")
        set(value) {
            _path = value
        }
    lateinit var privileges: List<AdminPrivilege>
    lateinit var authentication: List<Authentication>
    lateinit var interceptors: List<CallInterceptor>

    private var registeredAt: Throwable? = null
    private var isRegistered: Boolean = false
    fun markAsRegistered() {
        require(!isRegistered) {
            val first = registeredAt?.stackTraceToString() ?: "unknown"
            "Endpoint is already registered. (${this::class.simpleName}) First registration:\n$first"
        }
        isRegistered = true
        registeredAt = Throwable("$this")
    }

    open fun applyContext(context: Routing.Context) {
        val endPoint = this@EndPoint
        endPoint.path = context.route
        endPoint.privileges = context.privileges.toList()
        endPoint.authentication = context.authentications.toList()
        endPoint.interceptors = context.interceptors.toList()
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as EndPoint<*, *>

        if (path != other.path) return false
        if (privileges != other.privileges) return false
        if (authentication != other.authentication) return false
        if (interceptors != other.interceptors) return false

        return true
    }

    override fun hashCode(): Int {
        var result = path.hashCode()
        result = 31 * result + privileges.hashCode()
        result = 31 * result + authentication.hashCode()
        result = 31 * result + interceptors.hashCode()
        return result
    }

    override fun toString(): String {
        return "EndPoint(path='$path', privileges=$privileges, authentication=$authentication, interceptors=$interceptors))"
    }


}